(function () {
    templateType = "";
    /**
     *
     * @param $scope
     * @param CampaignDesignerService
     * @param PermissionService
     * @param DTOptionsBuilder
     * @param DTColumnBuilder
     * @param $state
     * @param $q
     * @param $compile
     * @param {DataTablesRenderer} renderer
     * @constructor
     */
    class CampaignTemplateListingController {

        constructor(
            $scope,
            CampaignDesignerService,
            PermissionService,
            DTOptionsBuilder,
            DTColumnBuilder,
            $state,
            $q,
            $compile
        ) {
            this.$scope = $scope;
            this.CampaignDesignerService = CampaignDesignerService;
            this.PermissionService = PermissionService;
            this.DTOptionsBuilder = DTOptionsBuilder;
            this.DTColumnBuilder = DTColumnBuilder;
            this.$state = $state;
            this.$q = $q;
            this.$compile = $compile;
        }

        $onInit() {
            this.$scope.campaignDesignerUrls = new Dashboard.Models.CampaignDesignerUrls()
                .initialiseUrls(
                    this.$state,
                    !this.isDraft()
                );

            const helper = new Dashboard.CampaignDesigner.TemplateListing(
                this.$scope,
                this.$state,
                this.PermissionService.userContext
            );

            helper.setupGrid(
                this.templateType,
                this.$scope,
                this.$q,
                this.CampaignDesignerService,
                this.DTOptionsBuilder,
                this.DTColumnBuilder,
                this.$compile
            )
        }

        goToBasicSetup() {
            this.$state.go(".manage", { brandId: this.$state.params.brandId });
        }

        isDraft() {
            return this.templateType === "draft";
        }

        isPublished() {
            return this.templateType === "published";
        }

        isArchived() {
            return this.templateType === "archived";
        }
    }

    angular
        .module("dashboard")
        .component("campaignTemplateListing",
            {
                templateUrl: "components/campaigndesigner/campaigntemplatelists/campaigntemplatelisting.9f768a62.html",
                bindings: { templateType: "@" },
                controller: [
                    "$scope",
                    "CampaignDesignerService",
                    "PermissionService",
                    "DTOptionsBuilder",
                    "DTColumnBuilder",
                    "$state",
                    "$q",
                    "$compile",
                    CampaignTemplateListingController ]
            });
})();
